module.exports = __webpack_public_path__ + "static/media/uploadNewIcon.4819f325.svg";